import { getLanguageLabel } from "@axon-enterprise/i18n";
import { LanguageContext } from "@axon-enterprise/i18n-helpers";
import { LanguageIcon } from "@axon-enterprise/icon";
import { LinkButton, WithIcon } from '@axon-enterprise/spark';
import React, { useState, useContext } from 'react';

import LanguageSelectorDialog from './language-selector/LanguageSelectorDialog';

/**
 * Language menu wrapper that accesses language from i18n-helpers context
 * No prop drilling needed - uses context provided by LanguageContainer
 */
export const LanguageMenuWrapper: React.FC = () => {
  const { language: currentLanguage } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  
  const handleClose = () => {
    setOpen(false);
  };

  const handleLanguageDialogOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <LanguageSelectorDialog 
        open={open} 
        onClose={handleClose}
      />
      <LinkButton
        variant={LinkButton.variants.underlined}
        onClick={handleLanguageDialogOpen}
      >
        <WithIcon icon={LanguageIcon} space="xs">
          {getLanguageLabel(currentLanguage)}
        </WithIcon>
      </LinkButton>
    </>
  );
};

export default LanguageMenuWrapper;

